<template>
  <div class="grid-column ai-c jc-s gap-10">
    <img
      :src="batteryImgSrc"
      alt="battery"
      class="img-size-16"
    />
    <img
      :src="connImgSrc"
      alt="conn"
      class="img-size-24"
    />
  </div>
</template>

<script>
import noBatteryImg from '@shared/assets/img/device/dead-battery.png';
import criticalBatteryImg from '@shared/assets/img/device/critical-battery.png';
import lowBatteryImg from '@shared/assets/img/device/low-battery.png';
import healthyBatteryImg from '@shared/assets/img/device/good-battery.png';
import noConnImg from '@shared/assets/img/performance-summary/no-connectivity.svg';
import lowConnImg from '@shared/assets/img/performance-summary/low-connectivity.svg';
import highConnImg from '@shared/assets/img/performance-summary/good-connectivity.svg';

export default {
  name: 'SensorStatus',
  props: {
    status: Object,
  },
  computed: {
    batteryImgSrc() {
      if (!this.status) {
        return noBatteryImg;
      }
      const {
        battery,
      } = this.status;
      let img = noBatteryImg;
      if (battery === 'Good') {
        img = healthyBatteryImg;
      }
      if (battery === 'Low') {
        img = lowBatteryImg;
      }
      if (battery === 'Warning') {
        img = criticalBatteryImg;
      }
      return img;
    },
    connImgSrc() {
      if (!this.status) {
        return noConnImg;
      }
      const {
        sensorRatio,
      } = this.status;
      let img = noConnImg;
      if (sensorRatio > 0.5) {
        img = highConnImg;
      }
      if (sensorRatio <= 0.5 && sensorRatio > 0.1) {
        img = lowConnImg;
      }
      return img;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
